import { useCallback } from "react";
import { Button } from "@/components/buttons/Button";
import ExternalLinkIcon from "@/common/images/icons/external-link.svg?react";
import OnlyFansIcon from "./images/onlyfans.svg?react";
import "./AdSideBarItem.scss";

interface IAdSideBarItem {
  image: string;
  name: string;
  link: string;
}

export const AdSideBarItem = ({
  image,
  name,
  link,
}: IAdSideBarItem) => {
  const onClick = useCallback(() => {
    window.location.href = link;
  }, []);

  return (
    <div className="AdSideBarItem">
      <div className="creatorImage">
        <img src={image} alt={name} />
        <OnlyFansIcon className="badgeIcon" />
      </div>
      <span className="creatorTitle">{name}</span>
      <Button className="creatorLink" fullWidth onClick={onClick} size="s" variant="secondary">Visit Page <ExternalLinkIcon /></Button>
    </div>
  );
};
